import {IHostingRedirectsState} from "../reducers/hosting-redirects.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {HostingRedirectsDataMapper} from "../../websites/website/hosting/redirects/hosting-redirects-mapper";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getRedirectsHostingState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingRedirects);

export const getRedirects = (websiteId: number) => createSelector(getRedirectsHostingState,
  (state: IHostingRedirectsState) => {
    if (state.entities[websiteId].entities) {
      const recordsMap = Object.values(state.entities[websiteId].entities).map((record: any) => {
        record = HostingRedirectsDataMapper.map(record);
        return record;
      });
      return Object.values(recordsMap);
    }
    return null
  }
);

export const getRedirectsMap = (websiteId: number) => createSelector(getRedirectsHostingState,
  (state: IHostingRedirectsState) =>
    state.entities[websiteId]
);

export const getRedirect = (websiteId: number) => createSelector(getRedirectsHostingState,
    (state: IHostingRedirectsState) =>
      state.entities[websiteId]
);

export const getRedirectsLoading = (websiteId: number) => createSelector(getRedirectsHostingState,
  (state: IHostingRedirectsState) =>
    state.entities[websiteId].loading
);

export const getRedirectsLoaded = (websiteId: number) => createSelector(getRedirectsHostingState,
  (state: IHostingRedirectsState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
